function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "75.9987199%",
  y1: "92.3670164%",
  x2: "50%",
  y2: "-21.0531109%",
  id: "linearGradient-1"
}, React.createElement("stop", {
  stopColor: "#3023AE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#53A0FD",
  offset: "58.638909%"
}), React.createElement("stop", {
  stopColor: "#C9F3F5",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "63.5251666%",
  y1: "93.7810635%",
  x2: "78.7541233%",
  y2: "-17.3061585%",
  id: "linearGradient-2"
}, React.createElement("stop", {
  stopColor: "#3023AE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#53A0FD",
  offset: "58.638909%"
}), React.createElement("stop", {
  stopColor: "#C9F3F5",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "63.8607629%",
  y1: "92.7865542%",
  x2: "79.4675915%",
  y2: "-15.7772646%",
  id: "linearGradient-3"
}, React.createElement("stop", {
  stopColor: "#3023AE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#53A0FD",
  offset: "58.638909%"
}), React.createElement("stop", {
  stopColor: "#C9F3F5",
  offset: "100%"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Practice-Management-v0",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Main-dashboard",
  transform: "translate(-28.000000, -30.000000)"
}, React.createElement("g", {
  id: "main-nav",
  transform: "translate(-6.000000, 0.000000)"
}, React.createElement("g", {
  id: "Dark-Background-Full-Logo-",
  transform: "translate(34.000000, 30.000000)"
}, React.createElement("g", {
  id: "Group-3-Copy-2"
}, React.createElement("path", {
  d: "M26.395071,25.3981745 C31.0980383,23.3897743 34.3900315,18.7647656 34.3911551,13.380851 C34.3926623,6.15544526 28.466545,0.299318649 21.1548015,0.300825849 C15.7155435,0.301947573 11.0417354,3.54435492 9.00398277,8.17952646 C16.3390712,5.50863649 22.0953837,8.82625878 24.8307453,12.558257 C27.5661069,16.2902552 28.1385561,20.8932879 26.395071,25.3981745 Z",
  id: "Oval",
  fill: "url(#linearGradient-1)",
  transform: "translate(21.697569, 12.849500) rotate(1.000000) translate(-21.697569, -12.849500) "
}), React.createElement("path", {
  d: "M18.0051489,32.1189919 C22.6530571,30.0856581 25.9071887,25.4047652 25.909435,19.9565759 C25.912447,12.6449113 20.057477,6.72007862 12.8319924,6.72309062 C7.45690291,6.72533327 2.83754973,10.0074002 0.822859888,14.698322 C8.07197682,11.9940539 13.7596806,15.3501116 16.4619853,19.1261067 C19.16429,22.9021019 19.7290154,27.5599702 18.0051489,32.1189919 Z",
  id: "Oval-Copy-4",
  fill: "url(#linearGradient-2)",
  transform: "translate(13.366147, 19.421041) rotate(-92.000000) translate(-13.366147, -19.421041) "
}), React.createElement("path", {
  d: "M25.1979859,39.7154405 C29.9005511,37.708017 33.1915914,33.0837036 33.1915914,27.6998087 C33.1915914,20.4744293 27.2642308,14.617102 19.952461,14.617102 C14.5131834,14.617102 9.84003477,17.858534 7.80324178,22.4932687 C15.1377997,19.8239007 20.8948253,23.1426978 23.6309755,26.8752466 C26.3671257,30.6077954 26.9405374,35.2109295 25.1979859,39.7154405 Z",
  id: "Oval-Copy-6",
  fill: "url(#linearGradient-3)",
  transform: "translate(20.497417, 27.166271) rotate(-180.000000) translate(-20.497417, -27.166271) "
}), React.createElement("path", {
  d: "M33.4695366,33.3632746 C38.1174447,31.3299409 41.3715763,26.6490479 41.3738227,21.2008586 C41.3768347,13.889194 35.5218648,7.96436137 28.2963801,7.96737336 C22.9212906,7.96961601 18.3019374,11.2516829 16.2872476,15.9426048 C23.5363645,13.2383367 29.2240683,16.5943944 31.9263731,20.3703895 C34.6286778,24.1463846 35.1934032,28.8042529 33.4695366,33.3632746 Z",
  id: "Oval-Copy-7",
  fill: "url(#linearGradient-2)",
  transform: "translate(28.830535, 20.665324) rotate(88.000000) translate(-28.830535, -20.665324) "
}))))));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "42px",
    height: "40px",
    viewBox: "0 0 42 40",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.026fe7bf.svg";
export { ForwardRef as ReactComponent };